import React, { Dispatch, useMemo } from 'react';

import { getColumnSorting } from 'helpers/getColumnSorting';
import { InfoTableSortIndicator } from './info-table-sort-indicator';
import { IInfoTableColumn, IInfoTableColumnSorting } from 'types/info-table';

import styles from './styles.module.css';

interface IInfoTableHeaderCellProps<T> {
  column: IInfoTableColumn<T>;
  columnsSorting?: IInfoTableColumnSorting[];
  sortColumnData?: Dispatch<IInfoTableColumnSorting>;
}

export const InfoTableHeaderCell = <T,>(props: IInfoTableHeaderCellProps<T>) => {
  const { column, columnsSorting, sortColumnData } = props;

  const { isSortable, sortBy } = useMemo(() => {
    const sortingInfo = columnsSorting?.find((sortingInfo) => sortingInfo.id === column.accessorKey);

    return { sortBy: sortingInfo?.sortBy || null, isSortable: !!sortingInfo };
  }, [columnsSorting]);

  const handleSorting = () => {
    if (isSortable && sortColumnData) {
      sortColumnData({ id: column.accessorKey, sortBy: getColumnSorting(sortBy) });
    }
  };

  return (
    <div
      className={styles.cell}
      style={{
        maxWidth: `${column.width ? `${column.width}px` : '100%'}`,
        minWidth: `${column.minWidth ? `${column.minWidth}px` : 'unset'}`,
        cursor: isSortable ? 'pointer' : 'default',
      }}
      onClick={handleSorting}
    >
      <span>
        {column.header}
        {isSortable && <InfoTableSortIndicator sortBy={sortBy} />}
      </span>
    </div>
  );
};
